import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    routes: [{
        path: '/',
        redirect: '/home'
    },

    {
        path: '/home',
        component: () => import('./views/Home.vue')
    },
    {
        path:'/case',
        component:()=>import('./views/Case.vue')
    },
    {
        path:'/details',
        component:()=>import('./views/Details.vue')
    },
]
})